/* eslint-disable no-sequences */
import React, { useState } from 'react';
import styled from 'styled-components';
import NumberFormat from 'react-number-format';
import ErrorIcon from '@material-ui/icons/Error';
import ModalTableCheckboxSearch from '../../../../components/ModalTableCheckboxSearch';
import { materialType, materialTypeOptionList } from '../../../../constants/order';
import { materialTableHeader, materialTableKey } from './constants';
import { Text } from '../../../../components';
import { Colors } from '../../../../constants';
import { Tooltip } from '@material-ui/core';
import { OrderCategoryEnum } from '../../../../constants/OrderCategory';

const StyledQuantityText = styled(Text)`
  display: flex;
  align-items: center;
  color: ${Colors.GRAY};
`;

const TextStyled = styled(Text)`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 190px;
`;

const StyledIcon = styled(ErrorIcon)`
  margin-right: 4px;
`;

const StyledTypeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 16px;
  background-color: ${({ type }) =>
    backgroundColorByType[type] ?? Colors.BLUE_VIVID_LIGHT};
  padding: 6px 10px;
  width: min-content;
`;

const StyledTypeText = styled(Text)`
  color: ${({ type }) => colorsByType[type] ?? Colors.GREEN_LIGHT};
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`;

const colorsByType = {
  amostra_gratis: Colors.LAVANDER_DARK,
  amostra_gratis_tributada: Colors.BLUE_GRAY_DARK,
};

const backgroundColorByType = {
  amostra_gratis: Colors.LAVANDER_LIGHT,
  amostra_gratis_tributada: Colors.BLUE_GRAY_LIGHT,
};

const translateColumnType = (category) => {
  switch (category) {
    case OrderCategoryEnum.PROMOTIONAL:
      return "PROMO";
    case OrderCategoryEnum.AMOSTRA_GRATIS:
      return "AMG";
    case OrderCategoryEnum.AMOSTRA_GRATIS_TRIBUTADA:
      return "AGT";
    default:
      return "--";
  }
};

const MaterialModalTable = ({
  handleRefresh,
  agentSelectedList = [],
  ...props
}) => {
  const [isRefresh, setIsRefresh] = useState(false);
  const _renderBasicTextCell = (value, list, index) => (
    <>
      {list[index].availableQuantity > 0 ? (
        <TextStyled>
          {(value === parseInt(value, 10)) ? (
            <NumberFormat
              value={value}
              displayType="text"
              decimalSeparator=","
              thousandSeparator={true, '.'}
            />
          ) : (
            value
          )}
        </TextStyled>
      ) : (
        <>
          {(value === parseInt(value, 10)) ? (
            <StyledQuantityText>
              <StyledIcon
                fontSize="small"
              />
              INDISPONÍVEL
            </StyledQuantityText>
          ) : (
            <StyledQuantityText>
              {value}
            </StyledQuantityText>
          )}
        </>
      )}
    </>
  );

  const _renderTypeTextCell = (translatedValue, originalValue) => (
    <Tooltip title={translatedValue || ""} arrow placement="top">
      <StyledTypeContainer type={originalValue}>
        <StyledTypeText type={originalValue}>
          {translatedValue || "--"}
        </StyledTypeText>
      </StyledTypeContainer>
    </Tooltip>
  );

  const columnConfig = {
    [materialTableKey.MATERIAL]: {
      order: 1,
    },
    [materialTableKey.MATERIAL_TYPE]: {
      order: 2,
    },
    [materialTableKey.QUANTITY]: {
      order: 3,
    },
  };

  const components = {
    [materialTableKey.MATERIAL]: _renderBasicTextCell,
    [materialTableKey.MATERIAL_TYPE]: (value) =>
      _renderTypeTextCell(translateColumnType(value), value),
    [materialTableKey.QUANTITY]: _renderBasicTextCell,
  };

  return (
    <ModalTableCheckboxSearch
      title="Selecione um material"
      placeholder={(option) => materialType.NAME === option.type ? 'Nome do material' : 'Código do material'}
      tableColumnConfig={columnConfig}
      tableComponents={components}
      searchTypeList={materialTypeOptionList}
      tableHandleHeaderTitle={(key) => materialTableHeader[key]}
      handleRefresh={() => {
        handleRefresh();
        setIsRefresh(true);
      }}
      isRefresh={isRefresh}
      disableConfirm
      agentSelectedList={agentSelectedList}
      {...props}
    />
  );
};

export default MaterialModalTable;
